// extracted by mini-css-extract-plugin
export default {"title":"title__bvoMX","grid":"grid__lVGpM","bucket":"bucket__6SBwm","icon-add":"icon-add__7FyaH","iconAdd":"icon-add__7FyaH","check":"check__hUruA"};